import { render, staticRenderFns } from "./CheckLoginAvailability.vue?vue&type=template&id=bfa1df60&scoped=true&"
import script from "./CheckLoginAvailability.vue?vue&type=script&lang=js&"
export * from "./CheckLoginAvailability.vue?vue&type=script&lang=js&"
import style0 from "./CheckLoginAvailability.vue?vue&type=style&index=0&id=bfa1df60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa1df60",
  null
  
)

/* custom blocks */
import block0 from "./CheckLoginAvailability.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

component.options.__file = "CheckLoginAvailability.vue"
export default component.exports